export const aboutData = {
  brand: {
    title: '伦理剧精选',
    subtitle: '感动人心的家庭情感故事汇聚之地',
    intro: '伦理剧精选成立于2020年，是国内领先的伦理剧内容推荐平台。我们致力于为观众筛选最优质的伦理剧作品，提供深度的剧情解析、专业的观看指南和温暖的情感共鸣。在快节奏的现代生活中，我们希望成为您寻找心灵慰藉的精神家园。',
    mission: '让每一部好剧被看见，让每一份感动被珍藏',
    vision: '成为华语世界最具影响力的伦理剧推荐与讨论社区',
    values: ['品质优先', '真诚推荐', '深度解读', '温暖陪伴'],
  },
  reputation: {
    stats: [
      { value: '500万+', label: '累计用户' },
      { value: '2000+', label: '剧集收录' },
      { value: '98%', label: '好评率' },
      { value: '50万+', label: '日均浏览' },
    ],
    testimonials: [
      {
        name: '张先生',
        role: '资深剧迷',
        content: '自从发现了伦理剧精选，我再也不用到处找好剧了。每一篇解析都写得特别走心，看完文章再去看剧，感受完全不同。',
        rating: 5,
      },
      {
        name: '李女士',
        role: '影视从业者',
        content: '作为行业从业者，伦理剧精选的内容质量让我印象深刻。他们不只是推荐剧，更是用心的文化传播者。',
        rating: 5,
      },
      {
        name: '王同学',
        role: '大学生',
        content: '每次看完一部好剧，第一时间就来这里看解析。能看到不同角度的解读，还能跟其他剧迷一起讨论，超棒的体验！',
        rating: 5,
      },
    ],
  },
  contact: {
    email: 'contact@lunliju.example.com',
    wechat: '伦理剧精选',
    weibo: '@伦理剧精选',
    phone: '400-888-9999',
    address: '北京市朝阳区文化创意产业园区A座',
    workHours: '周一至周五 9:00-18:00',
  },
  faq: [
    {
      question: '伦理剧精选的内容是如何筛选的？',
      answer: '我们的编辑团队由资深影视评论人和专业编剧组成，每部推荐剧集都经过至少三位编辑的审看和讨论。我们坚持以内容质量为第一标准，不受商业因素影响，确保每一篇推荐都值得信赖。',
    },
    {
      question: '如何第一时间获取最新推荐？',
      answer: '您可以关注我们的微信公众号「伦理剧精选」或微博账号「@伦理剧精选」，我们会在第一时间推送最新剧集推荐和深度解析。也可以订阅我们的邮件通讯，每周五准时收到一周精选汇总。',
    },
    {
      question: '可以投稿推荐自己喜欢的伦理剧吗？',
      answer: '当然可以！我们非常欢迎剧迷投稿。您可以将您的剧评发送至 contact@lunliju.example.com，我们的编辑团队会认真审阅每一篇来稿，优秀稿件将被发布在网站上并注明作者。',
    },
    {
      question: '网站上的伦理剧可以在线观看吗？',
      answer: '伦理剧精选是一个内容推荐和解析平台，我们提供详细的剧集介绍、深度解析和观看指南，但不直接提供视频播放服务。每篇文章中我们会标注该剧的观看平台，方便您前往对应平台观看。',
    },
    {
      question: '伦理剧精选的评分标准是什么？',
      answer: '我们的评分综合了剧情质量、表演水平、制作水准、情感共鸣度和社会影响力五个维度。每位编辑独立打分后取平均值，同时也会参考豆瓣、IMDb等平台的评分作为辅助参考。',
    },
  ],
};